import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import styles from './Placeholder.module.scss';

type TProps = {
  className?: string;
  imageSrc?: string;
  title?: string;
  description?: string;
};

export const Placeholder = ({ className, imageSrc, title, description, children }: PropsWithChildren<TProps>) => (
  <div className={classNames(styles.container, className)}>
    <div className={styles['content-wrapper']}>
      {imageSrc && (
        <img
          src={imageSrc}
          alt="Плейсхолдер"
          className={styles.image}
        />
      )}
      {title && <div className={styles.title}>{title}</div>}
      {description && <p className={styles.description}>{description}</p>}
      {children && <div className={styles.children}>{children}</div>}
    </div>
  </div>
);
